import Radium from 'radium';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { semanticColors } from '../../../Globals/styles';
import { httpGet, httpPut, httpPost } from '../../../Util/http';
import Feed from './feed'


class DepartmentFeed extends Component {
    constructor(props) {
        super(props)
        this.state = {
            feed: [],
            executed: false
        }
    }
    componentDidMount() {
        setTimeout(() => {
            let _url = process.env.REACT_APP_webApiEndPoint + 'api/department/' + this.props.departmentId + '/feed?skip=0&take=100';
            httpGet(_url)
                .then(resp => resp.json())
                .then(resp => this.setState({
                    feed: resp
                }))
        }, 400)
    }

    render() {
        return (
            <div style={{
                height: '590px',
            }}>
                <div style={styles.Heading}>
                    <div style={styles.headingText}>Aktivitetsfeed</div>
                </div>
                <Feed
                    feeds={this.state.feed}
                    workplaces={this.props.workplaces}
                    goToDailyReport={this.props.goToDailyReport}
                    gotoWorkplace={this.props.gotoWorkplace}
                    gotoAPV={this.props.gotoAPV}
                    moreFeeds={(length) => {
                        if (!this.state.executed) {
                            this.setState({
                                executed: true
                            })
                            setTimeout(() => {
                                let _url = process.env.REACT_APP_webApiEndPoint + 'api/department/' + this.props.departmentId + '/feed?skip=' + length + '&take=100';
                                httpGet(_url)
                                    .then(resp => resp.json())
                                    .then(resp => {
                                        if (resp.length > 0) {
                                            let feeds = this.state.feed;
                                            let conced = feeds.concat(resp)
                                            this.setState({
                                                feed: conced,
                                                prevLength: length,
                                                executed: false
                                            })
                                        }
                                    })
                            }, 100)
                        }
                    }}
                />
            </div>
        );
    }
}
var styles = {
    Heading: {
        paddingBottom: '1px',
        position: 'relative'
    },
    headingText: {
        display: 'inline-block',
        backgroundColor: 'white',
        width: '103.6%',
        padding: '5px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 600,
    },
}

export default Radium(DepartmentFeed)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/DepartmentFeed/index.js